"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleWithPanels = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const title_with_multiple_panels_1 = require("@ariessolutionsio/react-ecomm-ui/dist/components/PageSections/marketing/incentives/title-with-multiple-panels");
const classNames_1 = require("@ariessolutionsio/react-ecomm-ui/dist/utils/classNames");
const TitleWithPanels = (props) => {
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classNames_1.cn)(props.data?.theme === 'double_tree'
            ? 'bg-[#09194E] lg:px-20 lg:py-9'
            : 'bg-primary-800 lg:h-[300px] lg:px-24', 'flex w-full items-center justify-center py-10 sm:px-5'), children: (0, jsx_runtime_1.jsx)(title_with_multiple_panels_1.TitleWithMultiplePanels, { ...props }) }));
};
exports.TitleWithPanels = TitleWithPanels;
